<template>
  <div>
    <basic-container>
      <div>
        <el-form ref="form" :model="dtTableForm">
          <el-form-item label="服务类目名称">
            <div style="display: flex;width:300px;">
              <el-select v-model="dtTableForm.superiorId" placeholder="请选择服务类目名称" width="300" @change="selectSuperiorId"
                disabled>
                <el-option v-for="item in superiorIds" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="服务项目名称">
            <div style="display: flex;width:300px;">
              <el-select v-model="dtTableForm.serviceCategoryName" placeholder="请选择服务类目名称" width="300"
                @change="selectCategory" value-key="id" disabled>
                <el-option v-for="item in categoryTypes" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="动态表单">
            <div v-for="(item, index) in tableData1" :key="index">
              <el-table :data="item" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                <el-table-column prop="yyqd" label="预约渠道" min-width="120">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.clientType" placeholder="请选择服务类目名称" disabled width="300">
                      <el-option v-for="item in clientTypes" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <!-- <el-table-column
                  prop="glfws"
                  align="center"
                  min-width="160"
                  label="关联服务商"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.agentId"
                      placeholder="请选择关联服务商"
                      disabled
                      width="200"
                    >
                      <el-option
                        v-for="item in agentIds"
                        :key="item.id"
                        :label="item.company"
                        :value='item.id'
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column> -->
                <el-table-column prop="area" min-width="250" label="服务区域">
                  <template slot-scope="scope">
                    <div>
                      <el-input v-model="scope.row.area" disabled> </el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="fieldName" label="显示名称" min-width="150">
                  <template slot-scope="scope">
                    <el-input type="input" name="fieldName" v-model="scope.row.fieldName" :value="scope.row.fieldName"
                      placeholder="请输入名称"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="inputType" min-width="150" label="控件类型">
                  <template slot-scope="scope">
                    <el-select name="inputType" v-model="scope.row.inputType" placeholder="请选择控件类型" clearable>
                      <el-option v-for="item in inputTypes" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="dataSource" min-width="150" label="数据源">
                  <template slot-scope="scope">
                    <el-select name="dataSource" v-model="scope.row.dataSource" placeholder="请选择数据源"
                      :value="scope.row.dataSource" clearable>
                      <el-option v-for="item in dataSources" :key="item.id" :label="item.valueName" :value="item.id">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="isNull" label="是否为空" width="150">
                  <template slot-scope="scope">
                    <el-radio v-model="scope.row.isNull" label="YES">
                      是
                    </el-radio>
                    <el-radio v-model="scope.row.isNull" label="NO">
                      否
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="isPay" label="是否计费" width="150">
                  <template slot-scope="scope">
                    <el-radio v-model="scope.row.isPay" label="YES">
                      是
                    </el-radio>
                    <el-radio v-model="scope.row.isPay" label="NO">
                      否
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="isDownloadExcel" label="是否可下载Excel" width="150">
                  <template slot-scope="scope">
                    <el-radio v-model="scope.row.isExcel" label="YES">
                      是
                    </el-radio>
                    <el-radio v-model="scope.row.isExcel" label="NO">
                      否
                    </el-radio>
                  </template>
                </el-table-column>

                <el-table-column prop="isBindOtherWorkUser" label="是否绑定其他工程师" width="150">
                  <template slot-scope="scope">
                    <el-radio v-model="scope.row.isBindOtherWorkUser" label="YES">
                      是
                    </el-radio>
                    <el-radio v-model="scope.row.isBindOtherWorkUser" label="NO">
                      否
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="计费金额">
                  <template slot-scope="scope">
                    <el-input type="input" name="amount" v-model="scope.row.amount"
                      :value="scope.row.amount"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序">
                  <template slot-scope="scope">
                    <el-input type="input" name="sort" v-model="scope.row.sort" :value="scope.row.sort"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button type="danger" icon="el-icon-close" size="small"
                      @click="handleSteppingDelete(scope.$index, index)">删除
                    </el-button>
                  </template>
                </el-table-column>

                <el-table-column align="center" label="配置" width="150">
                  <template slot-scope="scope">
                    <el-button type="warning" icon="el-icon-plus" size="small"
                      @click="handleAddRows(scope.$index, index)">增加一行</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div style="width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px">
        <el-button type="primary" size="small" @click="submit">确定修改</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath } from "@/util/util";
import {
  findProject,
  findDynamicDetail,
  findAllSuperiorDepartment,
  findProvince,
  findCitys,
  findAreas,
  findDataSourceFields,
  findDataSourceAll,
  editDynamic,
} from "@/api/work/dtTable";
import { findAgentId } from "@/api/work/serviceItem";
import { findUserId } from "@/api/salesCloud/company";

export default {
  data() {
    return {
      categoryTypes: [],
      detailData: [],
      qd: [1, 2],
      isPas: false,
      inputTypes: [],
      dataSources: [],
      agentIds: [],
      auditors: DIC.SERVICEITEM_AUDITOR,
      clientTypes: DIC.SERVICEITEM_TYPE,
      superiorIds: [],
      areas: [],
      citys: [],
      provinces: [],
      dtTableForm: {},
      projectName: ["管道安装", "设备调试"],
      list: {
        fst: [],
        sed: [],
      },
      secondId: "设备调试",
      fstId: "管道安装",
      tableData1: {},
      userId: "",
      submitData: {},
    };
  },
  created() {
    findUserId().then((res) => {
      console.log(res);
      let data = JSON.parse(res.data);
      this.userId = data.id;
    });
    findDynamicDetail(this.$router.currentRoute.query.id).then((res) => {
      let data = JSON.parse(res.data);
      let superiorId = data.superiorId;
      let dataId = data.id;
      this.detailData = data;
      console.log(data);
      findProject().then((res) => {
        let adata = JSON.parse(res.data);
        this.superiorIds = adata;
        console.log(adata);
        this.dtTableForm.superiorId = superiorId;
        let params = {};
        params.superiorId = superiorId;
        findProject(params).then((res) => {
          console.log(res);
          let bdata = JSON.parse(res.data);
          this.categoryTypes = bdata;
          this.dtTableForm.serviceCategoryName = { id: dataId };
        });
      });
      findAgentId(this.userId).then((res) => {
        console.log(res);
        let obj = {};
        let submitObj = {};
        for (let i = 0; i < data.configs.length; i++) {
          console.log(data.configs);
          if (data.configs[i].obj.length == 0) {
            data.configs[i].obj = [{}];
          }
          if (data.configs[i].agentId == res.data) {
            console.log(data.configs[i].agentId, res.data, "if");
            obj[i] = [];
            for (let j = 0; j < data.configs[i].obj.length; j++) {
              if (data.configs[i].obj) {
                if (
                  data.configs[i].obj[j].inputType != undefined &&
                  data.configs[i].obj[j].inputType != null
                ) {
                  data.configs[i].obj[j].inputType =
                    data.configs[i].obj[j].inputType + "";
                }

                data.configs[i].obj[j].clientType = data.configs[i].clientType;
                data.configs[i].obj[j].agentId = data.configs[i].agentId;
                data.configs[i].obj[j].configId = data.configs[i].id;
                data.configs[i].obj[j].targetType = "CONFIG";

                data.configs[i].obj[j].area =
                  (data.configs[i].provinceName == null
                    ? ""
                    : data.configs[i].provinceName) +
                  (data.configs[i].cityName == null
                    ? ""
                    : data.configs[i].cityName) +
                  (data.configs[i].areaName == null
                    ? ""
                    : data.configs[i].areaName);
                console.log(data.configs[i].obj[j]);
                obj[i].push(data.configs[i].obj[j]);
              }
            }
          } else {
            console.log(data.configs[i].agentId, res.data, "else");
            submitObj[i] = [];
            for (let j = 0; j < data.configs[i].obj.length; j++) {
              if (data.configs[i].obj) {
                if (
                  data.configs[i].obj[j].inputType != undefined &&
                  data.configs[i].obj[j].inputType != null
                ) {
                  data.configs[i].obj[j].inputType =
                    data.configs[i].obj[j].inputType + "";
                }

                data.configs[i].obj[j].clientType = data.configs[i].clientType;
                data.configs[i].obj[j].agentId = data.configs[i].agentId;
                data.configs[i].obj[j].configId = data.configs[i].id;
                data.configs[i].obj[j].targetType = "CONFIG";

                data.configs[i].obj[j].area =
                  (data.configs[i].provinceName == null
                    ? ""
                    : data.configs[i].provinceName) +
                  (data.configs[i].cityName == null
                    ? ""
                    : data.configs[i].cityName) +
                  (data.configs[i].areaName == null
                    ? ""
                    : data.configs[i].areaName);
                console.log(data.configs[i].obj[j]);
                submitObj[i].push(data.configs[i].obj[j]);
              }
            }
          }
        }
        this.submitData = submitObj;
        console.log(submitObj);
        console.log(obj);
        this.tableData1 = obj;
      });
    });

    findDataSourceFields().then((res) => {
      let data = JSON.parse(res.data);
      this.inputTypes = data;
    });
    findDataSourceAll().then((res) => {
      let data = JSON.parse(res.data);
      this.dataSources = data.rows;
    });
    findAllSuperiorDepartment().then((res) => {
      let data = JSON.parse(res.data);
      this.agentIds = data;
      this.agentIds.push({ company: "社区", id: "0" });
    });
    findProvince().then((res) => {
      this.provinces = res.data;
      this.currentProvince = "";
      this.currentCity = "";
      this.currentArea = "";
    });
  },
  methods: {
    chooseProvince(e) {
      console.log(e);
      findCitys(e.id).then((res) => {
        this.citys = res.data;
        this.currentCity = "";
        console.log(this);
        this.currentArea = "";
      });
    },
    chooseCity(e) {
      findAreas(e.id).then((res) => {
        this.areas = res.data;
        this.currentArea = "";
        console.log(this);
      });
    },
    chooseArea() {
      console.log(this);
    },
    selectCategory(e) {
      console.log(e);
      if (e.channel == null) {
        this.$message({
          showClose: true,
          message: e,
          type: "error",
        });
        return;
      }
      let list = e.channel.split(",");
      console.log(list);
      let obj = {};
      for (let i in list) {
        console.log(e.configs[i]);
        let dtobj = {};
        dtobj.clientType = e.configs[i].clientType;
        // dtobj.agentId = e.configs[i].agentId;
        dtobj.configId = e.configs[i].id;
        dtobj.targetType = "CONFIG";
        dtobj.area =
          (e.configs[i].provinceName == null ? "" : e.configs[i].provinceName) +
          (e.configs[i].cityName == null ? "" : e.configs[i].cityName) +
          (e.configs[i].areaName == null ? "" : e.configs[i].areaName);
        list[i] = [];
        list[i].push(dtobj);
        obj[i] = list[i];
      }
      console.log(obj);
      this.tableData1 = obj;
    },
    selectSuperiorId() {
      // findProject(params).then(res => {
      //   console.log(res);
      //   let data = JSON.parse(res.data);
      //   this.categoryTypes = data;
      // });
    },
    submit() {
      let item = {
        close: true,
        label: "编辑服务清单",
        value: "/work/dtTable/edit",
      };
      console.log(this.tableData1);
      console.log(this.submitData);
      let submitObj = {};
      // submitObj =  Object.assign(this.tableData1, this.submitData)
      // console.log(submitObj);
      for (let i in this.tableData1) {
        console.log(i);
        console.log(this.tableData1[i]);
        submitObj[i] = this.tableData1[i];
      }
      for (let j in this.submitData) {
        console.log(j);
        submitObj[j] = this.submitData[j];
      }
      console.log(submitObj);
      let list = [];
      for (let item in submitObj) {
        console.log(submitObj[item]);
        submitObj[item];
        let obj = {};
        obj.id = submitObj[item][0].configId;
        obj.dynamics = submitObj[item];
        list.push(obj);
      }
      console.log(list);
      let params = {};
      params = list;
      editDynamic(params).then((res) => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/dtTable",
              label: "服务清单管理",
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query,
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      console.log(index, row);
      // this.tableData.splice(index, 1);
      console.log(this.tableData1[row].length);
      if (this.tableData1[row].length == 1) {
        this.$message({
          showClose: true,
          message: "服务清单不能为空",
          type: "error",
        });
      } else {
        this.tableData1[row].splice(index, 1);
      }
    },
    handleAddRows(index, row) {
      console.log(this.tableData1[row]);
      console.log(index, row);
      let list = {
        targetType: "CONFIG",
      };
      // list.push(this.tableData1[row][0]);
      this.tableData1[row].push(list);
    },
    // eslint-disable-next-line no-unused-vars
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 1) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (columnIndex === 12) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    inSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 6) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>

<style></style>
